import { z } from 'zod';

// 基本的なユーザー情報のスキーマ
export const UserSchema = z.object({
  id: z.union([z.string(), z.number()]),
  email: z.string().email(),
  name: z.string(),
  role: z.enum(['user', 'admin']).optional(),
  hospital_id: z.union([z.string(), z.number(), z.null()]).optional(),
  hospital_name: z.string().optional(),
  icon_path: z.string().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
  deleted_at: z.string().nullable().optional(),
});

export type User = z.infer<typeof UserSchema>;

// 全ユーザー取得レスポンスのスキーマ
export const GetAllUsersResSchema = z.array(UserSchema);
export type GetAllUsersRes = z.infer<typeof GetAllUsersResSchema>;

// 単一ユーザー取得レスポンスのスキーマ
export const GetUserByIdResSchema = UserSchema;
export type GetUserByIdRes = z.infer<typeof GetUserByIdResSchema>;

// ユーザー権限更新リクエストのスキーマ
export const UpdateUserRoleReqSchema = z.object({
  role: z.enum(['user', 'admin'])
});
export type UpdateUserRoleReq = z.infer<typeof UpdateUserRoleReqSchema>;

// ユーザー権限更新レスポンスのスキーマ
export const UpdateUserRoleResSchema = UserSchema;
export type UpdateUserRoleRes = z.infer<typeof UpdateUserRoleResSchema>;

// ユーザー復元レスポンスのスキーマ
export const RestoreUserResSchema = UserSchema;
export type RestoreUserRes = z.infer<typeof RestoreUserResSchema>;

// ユーザー削除レスポンスのスキーマ
export const DeleteUserResSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  user: UserSchema.optional()
});
export type DeleteUserRes = z.infer<typeof DeleteUserResSchema>;

// パスワードリセット（管理者発行型）レスポンスのスキーマ
export const ResetUserPasswordResSchema = z.object({
  message: z.string(),
  temporaryPassword: z.string(),
});
export type ResetUserPasswordRes = z.infer<typeof ResetUserPasswordResSchema>;

// ユーザー作成（管理者専用）レスポンスのスキーマ
export const CreateUserResSchema = z.object({
  message: z.string(),
  user: z.object({
    id: z.string(),
    email: z.string(),
    name: z.string().nullable(),
    role: z.string(),
    hospital_id: z.string().nullable(),
  }),
  temporaryPassword: z.string(),
});
export type CreateUserRes = z.infer<typeof CreateUserResSchema>; 